import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const ProductCard16 = ({ product, onClick }) => {
    const [wishlisted, setWishlisted] = useState(false);
    const [hovered, setHovered] = useState(false);

    const handleWishlistToggle = (e) => {
        e.stopPropagation();
        setWishlisted((prev) => !prev);
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;500;600;700&family=Poppins:wght@300;400;500&display=swap');
            `}</style>

            <div
                onClick={() => onClick && onClick(product)}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{
                    backgroundColor: '#FEF2E8',
                    border: `1px solid ${hovered ? '#B8860B' : 'rgba(184, 134, 11, 0.2)'}`,
                    cursor: 'pointer',
                    transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                    overflow: 'hidden',
                    boxShadow: hovered ? '0 8px 30px rgba(153, 27, 27, 0.1)' : 'none',
                }}
            >
                {/* Image Container */}
                <div
                    style={{
                        position: 'relative',
                        aspectRatio: '3 / 4',
                        overflow: 'hidden',
                    }}
                >
                    <img
                        src={product.image}
                        alt={product.name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transform: hovered ? 'scale(1.05)' : 'scale(1)',
                            transition: 'transform 0.5s ease',
                        }}
                    />

                    {/* Badge */}
                    {product.badge && (
                        <span
                            style={{
                                position: 'absolute',
                                top: '12px',
                                left: '12px',
                                backgroundColor: '#991B1B',
                                color: '#FFFFFF',
                                fontFamily: "'Poppins', sans-serif",
                                fontSize: '10px',
                                fontWeight: 500,
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                                padding: '4px 12px',
                            }}
                        >
                            {product.badge}
                        </span>
                    )}

                    {/* Wishlist Heart */}
                    <button
                        onClick={handleWishlistToggle}
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            width: '36px',
                            height: '36px',
                            backgroundColor: 'rgba(255, 248, 240, 0.85)',
                            border: 'none',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            backdropFilter: 'blur(4px)',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 248, 240, 0.95)')}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 248, 240, 0.85)')}
                    >
                        <Heart
                            size={18}
                            style={{
                                color: wishlisted ? '#991B1B' : '#6B7280',
                                fill: wishlisted ? '#991B1B' : 'none',
                                transition: 'color 0.3s ease, fill 0.3s ease',
                            }}
                        />
                    </button>
                </div>

                {/* Product Info */}
                <div style={{ padding: '16px' }}>
                    <h3
                        style={{
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: '14px',
                            fontWeight: 400,
                            color: '#1A1A1A',
                            margin: '0 0 8px 0',
                            lineHeight: 1.4,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {product.name}
                    </h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                            style={{
                                fontFamily: "'EB Garamond', serif",
                                fontSize: '18px',
                                fontWeight: 600,
                                color: '#B8860B',
                            }}
                        >
                            {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}
                        </span>
                        {product.originalPrice && (
                            <span
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontSize: '13px',
                                    color: '#6B7280',
                                    textDecoration: 'line-through',
                                }}
                            >
                                {typeof product.originalPrice === 'number'
                                    ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}`
                                    : product.originalPrice}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductCard16;
